export type PushToRouteOneState = {
    timestamp: string;
    wsResult: { message: string; ok: boolean };
    bffResult: { message: string; ok: boolean };
    status: string;
};

export enum PushToRouteOneStatus {
    Ready = 'ready',
    Waiting = 'waiting',
    Success = 'success',
    Failure = 'failure'
}
